"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hashtag = void 0;
var hashtag = {
  "viewBox": "0 0 64 64",
  "children": [{
    "name": "g",
    "attribs": {
      "id": "HASHTAG_1_",
      "enable-background": "new    "
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "HASHTAG"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "HASHTAG"
        },
        "children": [{
          "name": "g",
          "attribs": {},
          "children": [{
            "name": "g",
            "attribs": {},
            "children": [{
              "name": "path",
              "attribs": {
                "d": "M58,18h-8.689l2.613-11.325l0,0C51.973,6.458,52,6.232,52,6c0-1.657-1.343-3-3-3c-1.425,0-2.617,0.994-2.923,2.326l0,0\r\n\t\t\t\tL43.152,18H27.31l2.614-11.325l0,0C29.973,6.458,30,6.232,30,6c0-1.657-1.343-3-3-3c-1.425,0-2.617,0.994-2.923,2.326l0,0\r\n\t\t\t\tL21.152,18H12c-1.657,0-3,1.343-3,3s1.343,3,3,3h7.767l-3.692,16H6c-1.657,0-3,1.343-3,3s1.343,3,3,3h8.69l-2.613,11.325l0,0\r\n\t\t\t\tC12.027,57.542,12,57.768,12,58c0,1.657,1.343,3,3,3c1.425,0,2.617-0.994,2.923-2.326l0,0L20.848,46h15.841l-2.613,11.325l0,0\r\n\t\t\t\tC34.027,57.542,34,57.768,34,58c0,1.657,1.343,3,3,3c1.425,0,2.617-0.994,2.923-2.326l0,0L42.848,46H52c1.657,0,3-1.343,3-3\r\n\t\t\t\ts-1.343-3-3-3h-7.768l3.692-16H58c1.657,0,3-1.343,3-3S59.657,18,58,18z M38.075,40H22.233l3.692-16h15.843L38.075,40z"
              },
              "children": [{
                "name": "path",
                "attribs": {
                  "d": "M58,18h-8.689l2.613-11.325l0,0C51.973,6.458,52,6.232,52,6c0-1.657-1.343-3-3-3c-1.425,0-2.617,0.994-2.923,2.326l0,0\r\n\t\t\t\tL43.152,18H27.31l2.614-11.325l0,0C29.973,6.458,30,6.232,30,6c0-1.657-1.343-3-3-3c-1.425,0-2.617,0.994-2.923,2.326l0,0\r\n\t\t\t\tL21.152,18H12c-1.657,0-3,1.343-3,3s1.343,3,3,3h7.767l-3.692,16H6c-1.657,0-3,1.343-3,3s1.343,3,3,3h8.69l-2.613,11.325l0,0\r\n\t\t\t\tC12.027,57.542,12,57.768,12,58c0,1.657,1.343,3,3,3c1.425,0,2.617-0.994,2.923-2.326l0,0L20.848,46h15.841l-2.613,11.325l0,0\r\n\t\t\t\tC34.027,57.542,34,57.768,34,58c0,1.657,1.343,3,3,3c1.425,0,2.617-0.994,2.923-2.326l0,0L42.848,46H52c1.657,0,3-1.343,3-3\r\n\t\t\t\ts-1.343-3-3-3h-7.768l3.692-16H58c1.657,0,3-1.343,3-3S59.657,18,58,18z M38.075,40H22.233l3.692-16h15.843L38.075,40z"
                },
                "children": []
              }]
            }]
          }]
        }]
      }]
    }]
  }]
};
exports.hashtag = hashtag;